import { lazy, type ComponentType } from 'react';

const RELOAD_KEY = 'chunk-reload-retried';

// Retries a dynamic import once after a hard reload if the chunk fails to
// fetch (e.g. stale cached index.html referencing a chunk removed by a new
// deploy) instead of leaving the user on a permanently broken route. The flag
// is cleared on the next successful load, so every later deploy gets its own
// retry; a second failure in a row goes to the route error page.
export function lazyImport<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
) {
  return lazy(async () => {
    try {
      const mod = await factory();
      sessionStorage.removeItem(RELOAD_KEY);
      return mod;
    } catch (error) {
      if (!sessionStorage.getItem(RELOAD_KEY)) {
        sessionStorage.setItem(RELOAD_KEY, '1');
        window.location.reload();
        return new Promise<{ default: T }>(() => {});
      }
      throw error;
    }
  });
}
